import {useEffect, useRef} from 'react';
import Analytics from 'utils/Analytics';
import {surveyInstance} from 'screens/InsomniaSurvey/InsomniaSurvey';
import {readSeverityFromUrl} from 'surveys/osa_funnel/survey/severity';
import {BreakthroughRecovery} from '../animations/BreakthroughRecovery';
import {ScienceScreen} from './ScienceScreen';

export const AcceptanceScience = () => {
  const completedRef = useRef(false);
  useEffect(() => {
    return () => {
      if (completedRef.current) return;
      // Mark as completed when the user leaves this screen (advances forward).
      // We can't easily detect "Next clicked" from inside ScienceScreen, so
      // track on unmount as long as the survey state shows completion.
      if (surveyInstance.state === 'completed') {
        completedRef.current = true;
        Analytics.track('GLP-1 Funnel Grief Arc Completed', {
          severity: readSeverityFromUrl(),
          grief_anger: surveyInstance.getValue('grief_anger'),
          grief_bargaining: surveyInstance.getValue('grief_bargaining'),
          grief_realization: surveyInstance.getValue('grief_realization'),
          grief_mask_interest: surveyInstance.getValue('grief_mask_interest'),
        });
      }
    };
  }, []);

  return (
    <ScienceScreen
      bodyAfterAnimation
      headline="There's been a breakthrough in how we treat the underlying conditions that cause sleep apnea, no mask required."
      body={
        <>
          <p>
            <strong>CPAP masks and lifestyle change have been the standard options for decades.</strong> Most people who
            try them can&apos;t sustain them long enough to benefit.
          </p>
          <p>
            <strong>A class of medication has emerged that addresses the body&apos;s underlying conditions</strong> —
            not just the apnea events.
          </p>
        </>
      }
      animation={<BreakthroughRecovery />}
      callout="We'll ensure the time you spend in bed finally translates into the recovery you've been working for."
      analyticsShown="GLP-1 Funnel Grief Acceptance Science Viewed"
      analyticsSubmitted="GLP-1 Funnel Grief Acceptance Science Submitted"
    />
  );
};

export default AcceptanceScience;
